import "./NewsSlider.css";
import NewsBig from "./NewsBig";
import NewsSmall from "./NewsSmall";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import useFetch from "../../hooks/useFetch";
import config from "../../config";

const NewsSlider = () => {
  // fetch dat omezeny na sudy pocet x nejnovejsich
  const { loading, error, data } = useFetch(
    `${config.api}/api/news?populate[0]=image&sort[1]=date:desc&pagination[page]=1&pagination[pageSize]=6`
  );
  if (loading) return <p className="container">Načítání aktualit...</p>;
  if (error) return <p className="container">Error při načítání aktualit</p>;

  //? test
  //? console.log('Aktuality',data);

  const recentNews = data.data;

  //   posunuti pole aktualit o jedno vpred aby to kolidovalo s velkou aktualitou (efekt stridani)
  const getSmallNews = (index) => {
    const smallNews = [];
    const newsCount = recentNews.length;

    const nextIndex = (index + 1) % newsCount;
    smallNews.push(recentNews[nextIndex]);

    const secondNextIndex = (index + 2) % newsCount;
    smallNews.push(recentNews[secondNextIndex]);
    return smallNews;
  };

  return (
    <div className="d-flex align-items-center">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-12 news-big-background">
            <Splide
              id="main-slider"
              options={{
                type: "loop",
                perPage: 1,
                perMove: 1,
                arrows: false,
                drag: false,
                autoplay: true,
                interval: 7000,
                pauseOnHover: false,
                pagination: false,
              }}
            >
              {data.data.map((news) => (
                <SplideSlide key={news.id}>
                  <NewsBig
                    id={news.documentId}
                    title={news.name}
                    alt={news.image.alternativeText}
                    image={`${config.api}${news.image.url}`}
                    date={news.date}
                    overview={news.overview}
                  />
                </SplideSlide>
              ))}
            </Splide>
          </div>
          <div className="col-lg-4 col-12 mt-2 mt-lg-0">
            <Splide
              id="small-slider"
              options={{
                type: "loop",
                perPage: 1,
                perMove: 1,
                arrows: false,
                drag: false,
                autoplay: true,
                interval: 7000,
                pauseOnHover: false,
                pagination: false,
                sync: "#main-slider",
              }}
            >
              {recentNews.map((news, index) => {
                const smallNews = getSmallNews(index);
                return (
                  <SplideSlide key={news.id}>
                    <NewsSmall news={smallNews} />
                  </SplideSlide>
                );
              })}
            </Splide>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NewsSlider;
